import { render } from "./CoursePageFAQ.vue?vue&type=template&id=75f203c3&scoped=true"
import script from "./CoursePageFAQ.vue?vue&type=script&lang=js"
export * from "./CoursePageFAQ.vue?vue&type=script&lang=js"

import "./CoursePageFAQ.vue?vue&type=style&index=0&id=75f203c3&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-75f203c3"

export default script